module.exports = __webpack_public_path__ + "img/UTKODA-12.299bcd52.jpg";